import React from 'react';
import PropTypes from 'prop-types';
import { SyncOutlined } from '@ant-design/icons';
import { useTheme } from '../../contexts/ThemeContext';
import { getErpIcon, getErpColor, getErpName } from '../../helpers/synchronizations';

/**
 * Componente para exibir ícone de ERP com background e fallback
 * @param {number|string} erpValue - Valor do ERP (0=Omie, 1=ContaAzul, 2=Nibo, 3=Excel)
 * @param {number} size - Tamanho do ícone (padrão: 32)
 * @param {number} iconSize - Tamanho da imagem/ícone interno (padrão: 20)
 * @param {boolean} showLabel - Se deve mostrar o label do ERP (padrão: false)
 * @param {string} customBg - Background customizado (opcional)
 * @param {object} style - Estilos adicionais
 */
const ErpIcon = ({ 
  erpValue, 
  size = 32, 
  iconSize = 20, 
  showLabel = false, 
  customBg = null,
  style = {} 
}) => {
  const { weakenColor } = useTheme();
  
  const erpIcon = getErpIcon(erpValue);
  const erpColor = getErpColor(erpValue);
  const erpName = getErpName(erpValue);
  
  const backgroundColor = customBg || (erpIcon ? '#f9f9f9' : weakenColor(erpColor, 0.12));
  const hasBorder = erpIcon && !customBg;

  const iconElement = (
    <div 
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.25), // 25% do tamanho para border-radius proporcional
        backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: hasBorder ? '1px solid #e8e8e8' : 'none',
        ...style
      }}
      title={erpName}
    >
      {erpIcon ? (
        <img 
          src={erpIcon} 
          alt={erpName} 
          style={{ 
            width: iconSize, 
            height: iconSize, 
            objectFit: 'contain' 
          }} 
        />
      ) : (
        <SyncOutlined 
          style={{ 
            fontSize: Math.round(iconSize * 0.8), 
            color: erpColor 
          }} 
        />
      )}
    </div>
  );

  if (showLabel) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {iconElement}
        <span style={{ fontWeight: 500 }}>{erpName}</span>
      </div>
    );
  }

  return iconElement;
};

ErpIcon.propTypes = {
  erpValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  size: PropTypes.number,
  iconSize: PropTypes.number,
  showLabel: PropTypes.bool,
  customBg: PropTypes.string,
  style: PropTypes.object
};

export default ErpIcon; 